import React from "react";
import { Link } from "react-router-dom";
import { Cog, RefreshCcw } from "lucide-react";
import { Button } from "../../../components/ui/button";
import RepositorySearchInput from "./RepositorySearchInput";
import RepositoryFilters from "./RepositoryFilters";
import RepositorySortSelect from "./RepositorySortSelect";
import { RepositoryFilterMode, RepositorySortMode } from "../types";

interface RepositoriesToolbarProps {
  query: string;
  filter: RepositoryFilterMode;
  owner: string;
  owners: string[];
  sort: RepositorySortMode;
  isLoading: boolean;
  onQueryChange: (value: string) => void;
  onFilterChange: (value: RepositoryFilterMode) => void;
  onOwnerChange: (value: string) => void;
  onSortChange: (value: RepositorySortMode) => void;
  onRefresh: () => void;
}

const RepositoriesToolbar = ({
  query,
  filter,
  owner,
  owners,
  sort,
  isLoading,
  onQueryChange,
  onFilterChange,
  onOwnerChange,
  onSortChange,
  onRefresh,
}: RepositoriesToolbarProps) => {
  return (
    <div className="sticky top-2 z-10 space-y-2 rounded-md border bg-background/95 p-3 backdrop-blur">
      <div className="flex flex-wrap items-center gap-2">
        <RepositorySearchInput value={query} onChange={onQueryChange} />
        <RepositoryFilters
          filter={filter}
          owner={owner}
          owners={owners}
          onChangeFilter={onFilterChange}
          onChangeOwner={onOwnerChange}
        />
        <RepositorySortSelect value={sort} onChange={onSortChange} />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading}>
          <RefreshCcw className="mr-2 h-4 w-4" />
          Refresh
        </Button>
        <Button asChild variant="outline" size="sm">
          <Link to="https://github.com/settings/connections/applications/" target="_blank">
            <Cog className="mr-2 h-4 w-4" />
            Change permissions
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default RepositoriesToolbar;
